<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Growing up on a farm and then travelling the world was the subject of Christine’s autobiography, <em>Changing Skies.</em> In <em>Blue</em>, she draws on these experiences to create a world where a life may be lived in more than one way. She lives in Sussex now.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7703ddda